// DO NOT EDIT. This file is automatically generated.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ingest: function() {
        return ingest;
    },
    Params: function() {
        return Params;
    },
    ParamSet: function() {
        return ParamSet;
    },
    ReadOnlyParamSet: function() {
        return ReadOnlyParamSet;
    },
    Trace: function() {
        return Trace;
    },
    TraceSet: function() {
        return TraceSet;
    },
    SerializesToString: function() {
        return SerializesToString;
    },
    CommitNumber: function() {
        return CommitNumber;
    },
    TimestampSeconds: function() {
        return TimestampSeconds;
    },
    CacheType: function() {
        return CacheType;
    },
    BugType: function() {
        return BugType;
    }
});
function Params(v) {
    return v;
}
function ParamSet(v) {
    return v;
}
function ReadOnlyParamSet(v) {
    return v;
}
function Trace(v) {
    return v;
}
function TraceSet(v) {
    return v;
}
function SerializesToString(v) {
    return v;
}
function CommitNumber(v) {
    return v;
}
function TimestampSeconds(v) {
    return v;
}
function CacheType(v) {
    return v;
}
function BugType(v) {
    return v;
}
var ingest;
(function(ingest) {
    function CL(v) {
        return v;
    }
    ingest.CL = CL;
})(ingest || (ingest = {}));
